import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import ClinicalNutrition from './pages/ClinicalNutrition';
import BloodBank from './pages/BloodBank';
import RadiologyLaboratory from './pages/RadiologyLab';
import InsurancePartners from './pages/InsurancePartners';
import Mortuary from './pages/Mortuary';
import PastoralCare from './pages/PastoralCare';
import AboutUs from './pages/AboutUs';
import Doctors from './pages/Doctors';
import Gynaecology from './pages/Gynaecology';
import EmergencyMedicine from './pages/EmergencyMedicine';
import Paediatrics from './pages/Paediatrics';
import Neonatology from './pages/Neonatology';
import GeneralMedicine from './pages/GeneralMedicine';
import Dental from './pages/Dental';
import GeneralSurgery from './pages/GeneralSurgery';
import Orthopaedics from './pages/Orthopaedics';
import EntAudiology from './pages/EntAudiology';
import PlasticSurgery from './pages/PlasticSurgery';
import ImageGallery from './pages/ImageGallery';
import VideoGallery from './pages/VideoGallery';
import Directions from './pages/Directions';
import BioMedical from './pages/BioMedical';
import QualityIndicators from './pages/QualityIndicators';
import VideoConsultation from './pages/VideoConsultation';
import ContactUs from './pages/ContactUs';
import HomeCare from './pages/HomeCare';
import Articles from './pages/Articles';
import ArticleDetails from './pages/ArticleDetails';
import Testimonials from './pages/Testimonials';
import NewsEvents from './pages/NewsEvents';
import NewsDetails from './pages/NewsDetails';
import Appoinment from './pages/Appoinment';
import DirectorsMessage from './pages/DirectorsMessage';
import GoverningBody from './pages/GoverningBody';
import DoctorDetails from './pages/DoctorDetails';
import Dermatology from './pages/Dermatology';
import Ophthalmology from './pages/Ophthalmology';
import Cardiology from './pages/Cardiology';
import Neurology from './pages/Neurology';

function App() {
	return (
		<Router>
			<div className="App">
				<Routes>
					<Route index element={<HomePage />} />
					<Route path="/privacy-policy" element={<PrivacyPolicy />} />
					<Route path="/terms-conditions" element={<TermsConditions />} />
					<Route path="/clinical-nutrition" element={<ClinicalNutrition />} />
					<Route path="/blood-bank" element={<BloodBank />} />
					<Route path="/radiology-laboratory" element={<RadiologyLaboratory />} />
					<Route path="/insurance-partners" element={<InsurancePartners />} />
					<Route path="/caritas-mortuary-services" element={<Mortuary />} />
					<Route path="/pastoral-care" element={<PastoralCare />} />
					<Route path="/about-caritas-matha" element={<AboutUs />} />
					<Route path="/doctors" element={<Doctors />} />
					<Route path="/doctor/:id" element={<DoctorDetails />} />
					<Route path="/gynaecology" element={<Gynaecology />} />
					<Route path="/emergency-medicine" element={<EmergencyMedicine />} />
					<Route path="/paediatrics-and-paediatrics-surgery" element={<Paediatrics />} />
					<Route path="/neonatology" element={<Neonatology />} />
					<Route path="/general-medicine" element={<GeneralMedicine />} />
					<Route path="/general-surgery" element={<GeneralSurgery />} />
					<Route path="/orthopaedics" element={<Orthopaedics />} />
					<Route path="/ent-audiology" element={<EntAudiology />} />
					<Route path="/plastic-surgery" element={<PlasticSurgery />} />
					<Route path="/dental" element={<Dental />} />
					<Route path="/image-gallery" element={<ImageGallery />} />
					<Route path="/video-gallery" element={<VideoGallery />} />
					<Route path="/directions-to-reach" element={<Directions />} />
					<Route path="/biomedicals" element={<BioMedical />} />
					<Route path="/quality-indicators" element={<QualityIndicators />} />
					<Route path="/video-consultation" element={<VideoConsultation />} />
					<Route path="/contact-us" element={<ContactUs />} />
					<Route path="/caritas-home-care" element={<HomeCare />} />
					<Route path="/articles" element={<Articles />} />
					<Route path="/article/:id" element={<ArticleDetails />} />
					<Route path="/testimonials" element={<Testimonials />} />
					<Route path="/news-and-events" element={<NewsEvents />} />
					<Route path="/news-and-events/:id" element={<NewsDetails />} />
					<Route path="/appointment" element={<Appoinment />} />
					<Route path="/director-message" element={<DirectorsMessage />} />
					<Route path="/governing-body" element={<GoverningBody />} />
					<Route path="/dermatology" element={<Dermatology />} />
					<Route path="/ophthalmology" element={<Ophthalmology />} />
					<Route path="/cardiology" element={<Cardiology />} />
					<Route path="/neurology" element={<Neurology />} />
				</Routes>
			</div>
		</Router>
	);
}

export default App;